import actions from './marketplace-auctions.actions';
import getters from './marketplace-auctions.getters';
import mutations from './marketplace-auctions.mutations';
import state from './marketplace-auctions.state';

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
